<template>
    <div class="footer">
        <a href="http://www.beian.miit.gov.cn" target="_blank">豫ICP备15023008号</a>
    </div>
</template>
<script>
export default {
    name: 'footer',
}
</script>

<style lang="stylus">
    @import '../style/footer'
</style>



// WEBPACK FOOTER //
// footer.vue?2d2bf164